import { useEffect, memo, useRef } from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import { useRouter } from '~/utils/navigation';
import queryString from 'query-string';
import { useDispatch } from 'react-redux';
import { changeLastProduct, updateMainContentLoading } from './ducks/index.js';
import { MainContentLoadingStatus } from './constants.js';
import { lastProduct as lastProductCookie } from '../../store/cookies.js';

const MainContentLoading = memo(() => {
	const dispatch = useDispatch();
	useEffect(() => {
		dispatch(updateMainContentLoading(MainContentLoadingStatus.LOADING));
	}, []); // eslint-disable-line react-hooks/exhaustive-deps
	return null;
});

const ProductRedirect = memo(({ product, children, triggerMainContentLoading = true }) => {
	const location = useLocation();
	const router = useRouter();
	const dispatch = useDispatch();
	const lastProduct = useRef(lastProductCookie());
	const onMountQueryString = queryString.parse(location.search);
	const forceLanding = onMountQueryString.lp && onMountQueryString.lp === '1';

	// run this on mount
	useEffect(() => {
		if (!lastProduct || lastProduct !== product) {
			dispatch(changeLastProduct(product));
			lastProduct.current = product;
		}
	}, []); // eslint-disable-line react-hooks/exhaustive-deps

	// effect for forceLanding redirection
	useEffect(() => {
		if (forceLanding) {
			const redirectPath = `/?${queryString.stringify(onMountQueryString)}`;
			router.push(redirectPath);
		}
	}, [forceLanding, onMountQueryString, router]);

	return (
		<>
			{triggerMainContentLoading && <MainContentLoading />}
			{children ?? <Outlet />}
		</>
	);
});

export default ProductRedirect;
